import { Label } from "@sede-x/shell-ds-react-framework";
import {
  RadioButtonSelected,
  RadioButtonUnselected
} from "@sede-x/shell-ds-react-framework/build/esm/components/Icon/components";
import { format } from "date-fns";
import { TMovement } from "ticketing/ticketing.types";
export const MovementChildDetails = ({
  childMovement,
  isActiveChild,
  onActiveChildChanged
}: {
  childMovement: Partial<TMovement>;
  isActiveChild: boolean;
  onActiveChildChanged: (child: Partial<TMovement>) => void;
}) => {
  return (
    <div
      className="movement-detail-container"
      role="none"
      onClick={e => {
        onActiveChildChanged(childMovement);
        e.stopPropagation();
      }}>
      {isActiveChild ? (
        <RadioButtonSelected style={{ width: "100%", height: "100%" }} fill="#ffc600" />
      ) : (
        <RadioButtonUnselected style={{ width: "100%", height: "100%" }} fill="#dddddc" />
      )}

      <Label style={{ color: "black" }} className="detail-label">
        {format(new Date(childMovement?.startDate!), "yyyy-MM-dd")}
      </Label>
      <Label style={{ color: "black" }} className="detail-label">
        {childMovement.product?.name}
      </Label>
      <Label style={{ color: "black" }} className="prefix-text">
        at
      </Label>
      <Label style={{ color: "black" }} className="detail-label-wide">
        {childMovement.titleTransferFacility?.name}
      </Label>
      <Label style={{ color: "black" }} className="prefix-text">
        Via
      </Label>
      <Label style={{ color: "black" }} className="detail-label">
        {childMovement.activityType?.name}
      </Label>
      <Label style={{ color: "black" }} className="prefix-text">
        From
      </Label>
      <Label style={{ color: "black" }} className="detail-label-narrow">
        {childMovement.recDeal?.contractNumber}
      </Label>
      <Label style={{ color: "black" }} className="prefix-text">
        To
      </Label>
      <Label style={{ color: "black" }} className="detail-label-narrow">
        {childMovement.delDeal?.contractNumber}
      </Label>
      <Label style={{ color: "black" }} className="detail-label">
        {childMovement.incoterm?.name}
      </Label>
      <div style={{ display: "flex" }}></div>
    </div>
  );
};
